<template>
	<div class="container">
		<!--块1-->
		<div class="block_1">
			<div class="block_1_main">
				<div class="left">
					<div class="list_box">
						<div class="list_el">
							<div class="img">
								<img src="../../assets/img/contact/icon_1.webp" />
							</div>
							<div class="tit">
								USA Address: 8940 Kenamar Dr<br />
								San Diego, CA 92121<br />
								USA Phone: +1 (858) 999-1525
							</div>
						</div>
						<div class="list_el">
							<div class="img">
								<img src="../../assets/img/contact/icon_1.webp" />
							</div>
							<div class="tit">
								China Address: NO 302 Building #6 Yuan<br />
								NO.26 Yongwang west Road, Daxing District, Beijing,<br /> P.R. China<br />
								China Phone: +86 (010) 69390660
							</div>
						</div>
						<div class="list_el">
							<div class="img">
								<img src="../../assets/img/contact/icon_2.webp" />
							</div>
							<div class="tit">
								Email:<br />
								<!-- General: <a href="mailto:info@UCreagent.com">info@UCreagent.com</a><br />
								Sales: <a href="mailto:sales@UCreagent.com">sales@UCreagent.com</a><br />
								Tech Support: <a href="mailto:support@Jtests.com">support@Jtests.com</a><br />
								Ag, Ab, NC Membrane: <a href="mailto:AM@Jtests.com">AM@Jtests.com</a><br />
								Lab Testing: <a href="mailto:CLlA@Jtests.com">CLlA@Jtests.com</a> -->
								<a href="mailto:info@UCreagent.com">info@UCreagent.com</a><br />
								<a href="mailto:sales@UCreagent.com">sales@UCreagent.com</a>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<contact></contact>
				</div>
			</div>
		</div>
		<!--块1-->
	</div>
</template>

<script>
import contact from '@/component/pc/contact.vue'  //联系我们组件
export default {
	components:{
		contact
	},
	data() {
		return {
			//
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	//块1
	.block_1{
		padding: 65px 0 80px 0;
		.block_1_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			.left{
				flex: 1;
				padding: 15px 50px 0 50px;
				.list_box{
					.list_el{
						display: flex;
						padding-bottom: 30px;
						.tit{
							flex: 1;
							font-size: 18px;
							a{
								color: #006BB3;
								text-decoration: underline;
							}
						}
						.img{
							padding: 1px 10px 0 0;
							img{
								width: 24px;
								height: auto;
							}
						}
					}
				}
			}
			.right{
				flex: 1;
			}
		}
	}
}
</style>